module.exports = "https://cdn.realtymogul.com/static/media/icon_search.d7dd3d26.svg";